///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProjectDTO } from '../../generated/shared-types.model';

@Injectable({ providedIn: 'root' })
export class ProjectFilesService {
    private readonly projectFilesUrl = 'api/project-files';

    constructor(private readonly http: HttpClient) {}

    importProjectInterchangeArchive(parentId: number, name: string, description: string, file: File): Observable<ProjectDTO> {
        const formData = new FormData();
        formData.append('parentId', parentId.toString());
        formData.append('name', name);
        formData.append('description', description);
        formData.append('file', file);

        return this.http.post<ProjectDTO>(`${this.projectFilesUrl}/interchange`, formData);
    }
}
